import type { TicketGeneratedResposnse, TicketGenerationRequestBody } from "@/types";
import axios from "axios";
import { runTimeConfig } from "@/config";

const token = runTimeConfig.VITE_TICKET_GENERATOR_AI_CHAT_API_KEY;

/**
 * Service to generate a ticket based on the input provided.
 * @param payload - The input to generate the ticket, of type TicketGenerationRequestBody
 * @returns The generated ticket details, of type TicketGeneratedResposnse
 */
export const GenerateTicketService = async (
  payload: TicketGenerationRequestBody
): Promise<TicketGeneratedResposnse> => {
  try {
    const response = await axios.post(
      `${runTimeConfig.VITE_TICKET_GENERATOR_AI_CHAT_BASE_URL}/generate-ticket-details`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      }
    );
    return response.data;
  } catch (error: any) {
    console.error("Error in generating ticket:", error);
    throw new Error(error?.response?.data?.message || "Error generating ticket");
  }
};
